import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useRef, lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { Process } from "@/components/site/Process";
import { Showcase } from "@/components/site/Showcase";
import { LocalSeo } from "@/components/site/LocalSeo";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { CookieBanner } from "@/components/site/CookieBanner";

// Lazy-load secondary and legal routes to reduce initial bundle size (eliminates unused-javascript audit)
const Impressum = lazy(() => import("@/components/site/Impressum").then(m => ({ default: m.Impressum })));
const Datenschutz = lazy(() => import("@/components/site/Datenschutz").then(m => ({ default: m.Datenschutz })));
const InstagramReelPlayer = lazy(() => import("@/components/reel/InstagramReelPlayer").then(m => ({ default: m.InstagramReelPlayer })));

const ScrollToAnchorOrTop = () => {
  const { pathname, hash } = useLocation();
  const isFirstMount = useRef(true);

  useEffect(() => {
    // Never jump to top on initial page load (prevents interrupting user scroll)
    if (isFirstMount.current) {
      isFirstMount.current = false;
      if (hash) {
        requestAnimationFrame(() => {
          const el = document.getElementById(hash.replace("#", ""));
          if (el) el.scrollIntoView({ behavior: "smooth" });
        });
      }
      return;
    }

    if (hash) {
      requestAnimationFrame(() => {
        const el = document.getElementById(hash.replace("#", ""));
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      });
      return;
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

const LandingPage = () => {
  return (
    <div className="relative min-h-screen bg-[#0A0A0A] text-foreground antialiased selection:bg-[#C5A059] selection:text-[#0A0A0A]">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Process />
        <Showcase />
        <LocalSeo />
        <Contact />
      </main>
      <Footer />
      <Toaster position="top-right" />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToAnchorOrTop />
      <Suspense fallback={<div className="min-h-screen bg-[#0A0A0A]" />}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/reel" element={<InstagramReelPlayer />} />
        </Routes>
      </Suspense>
      <CookieBanner />
    </BrowserRouter>
  );
}

export default App;
